import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { CheckCircleIcon } from 'assets/icons/check-circle'
import styled from 'styled-components'

interface Props {
  open: boolean
  onPrimaryAction: () => void
  onClose: () => void
}

export default function CourseGpsEditorGreenAutoMapSuccessDialog({
  open,
  onPrimaryAction,
  onClose,
}: Props): JSX.Element {
  return (
    <StyledDialog open={open} onClose={onClose} hideBackdrop>
      <StyledDialogContent>
        <SuccessBadge>
          <CheckCircleIcon width={30} height={30} />
        </SuccessBadge>
        <Title>All greens verified</Title>
        <ContentText>You've completed mapping all 18 holes. The course is ready to use.</ContentText>
      </StyledDialogContent>
      <StyledDialogActions>
        <PrimaryButton onClick={onPrimaryAction}>Finish</PrimaryButton>
      </StyledDialogActions>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: min(328px, calc(100vw - 32px));
    border-radius: 16px;
    border-top: 0.5px solid rgba(255, 255, 255, 0.15);
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.15);
    background: rgba(20, 24, 26, 0.7);
    backdrop-filter: blur(5px);
    color: #fff;
  }
`

const StyledDialogContent = styled(DialogContent)`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`

const StyledDialogActions = styled(DialogActions)`
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 32px 24px;
`

const SuccessBadge = styled.div`
  margin: auto auto 8px;
  color: #fff;
  background: #0bb163;
  border-radius: 16px;
  display: flex;
  width: 64px;
  height: 64px;
  justify-content: center;
  align-items: center;
`

const Title = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
`

const ContentText = styled(DialogContentText)`
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
`

const DialogButton = styled(Button)`
  width: 100%;
  height: 48px;
  border-radius: 12px;
  padding: 0 20px;
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
`

const PrimaryButton = styled(DialogButton)`
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.customPalette.light};

  &:hover {
    background: ${(props) => props.theme.palette.primary.dark};
  }
`
